import {
    Box,
    BoxProps,
    Stack,
    Typography,
    CircularProgress,
} from "@mui/material";
import Logo from "./Logo";

interface Props extends BoxProps {
    description?: string;
}
const Splashscreen = ({ description, sx }: Props) => {
    return (
        <Box
            component="main"
            sx={{
                display: "grid",
                placeItems: "center",
                height: "100vh",
                backgroundColor: "background.default",
                ...sx,
            }}
        >
            <Stack
                spacing={3}
                justifyContent="center"
                useFlexGap
                alignItems="center"
            >
                <Logo />
                <CircularProgress color="inherit" size={55} sx={{ my: 8 }} />
                <Typography
                    align="center"
                    variant="h6"
                    fontWeight={400}
                    textTransform="capitalize"
                >
                    {description}
                </Typography>
            </Stack>
        </Box>
    );
};

export default Splashscreen;
